<template>
    <li class="dropdown">
        <a class="dropdown-toggle" data-toggle="dropdown" >
            <img
                src="@/assets/cloud.png"
                alt="Usuario"
                style="width: 20px; height: 20px; border-radius: 10%; object-fit: scale-down; margin-right: 5px;"
            />
            Vapp
        </a>
        <ul class="dropdown-menu animated fadeOutUp" style="right: 0px; display: none; opacity: 1; border-radius: 16px;">

        <li><a :href="cons.links.vapp.rdWeb">Mis Aplicaciones</a></li>

        <li><router-link to="/restaurarPass">Olvidé mi contraseña VAPP</router-link></li>

        <li><router-link to="/infoUsuarioVapp">Consultar Info de usuario VAPP</router-link></li>
        </ul>
    </li>
</template>

<script>
import cons from '@/utils/const';
export default {
    name: "VappModulo",
    data() {
        return { cons };
    },
};
</script>
